import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-seller-product-all-product',
  templateUrl: './seller-product-all-product.component.html',
  styleUrls: ['./seller-product-all-product.component.scss']
})
export class SellerProductAllProductComponent implements OnInit {
  sellerId: string = '';
  categories: any[] = [];
  popularProducts: any[] = [];
  newlyArrivedProducts: any[] = [];
  topQualityProducts: any[] = [];
  bestOfferProducts: any[] = [];
  errorMessage: string = '';
  selectedCategory: string = 'all'; // Default selected category
  selectedCategoryType: string = 'default'; // 'default' or 'custom'
  products: any[] = [];
  vendorCateemageUrl = environment.ImageBaseUrl;
  sellerStoreDetails: any;

  @ViewChild('productsSection') productsSection!: ElementRef; // Reference to the products section

  constructor(
    private api: ApiServiceService,
    private activeRouter: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activeRouter.params.subscribe((vendor: any) => {
      this.sellerId = vendor['id'];
      if (this.sellerId) {
        this.getCategories();
        this.loadSellerProducts();
      }
    });

    this.getSellerStoreDetails();
    this.updateProductList(); // Load all products by default
  }

  getCategories() {
    this.api.getSellerCategories(this.sellerId).subscribe({
      next: (response) => {
        this.categories = response.categories;
      },
      error: (error) => {
        this.errorMessage = 'Failed to load categories.';
      }
    });
  }

  getSellerStoreDetails() {
    this.api.getSellerStoreDetails(this.sellerId).subscribe((details: any) => {
      this.sellerStoreDetails = details?.storeDetails;
    });
  }

  loadSellerProducts() {
    this.api.GetPopularProductsBySeller(this.sellerId).subscribe({
      next: (response) => {
        this.popularProducts = response.data;
        this.updateProductList();
      },
      error: (error) => {
        console.error('Error fetching popular products:', error);
      }
    });

    this.api.GetNewlyArrivedProductsBySeller(this.sellerId).subscribe({
      next: (response) => {
        this.newlyArrivedProducts = response.data;
        this.updateProductList();
      },
      error: (error) => {
        console.error('Error fetching newly arrived products:', error);
      }
    });

    this.api.GetTopQualityProductsBySeller(this.sellerId).subscribe({
      next: (response) => {
        this.topQualityProducts = response.data;
        this.updateProductList();
      },
      error: (error) => {
        console.error('Error fetching top quality products:', error);
      }
    });

    this.api.GetBestOfferProductsBySeller(this.sellerId).subscribe({
      next: (response) => {
        this.bestOfferProducts = response.data;
        this.updateProductList();
      },
      error: (error) => {
        console.error('Error fetching best offer products:', error);
      }
    });
  }

  updateProductList() {
    let allProducts = [
      ...(this.newlyArrivedProducts || []),
      ...(this.bestOfferProducts || []),
      ...(this.topQualityProducts || []),
      ...(this.popularProducts || [])
    ];

    if (this.selectedCategoryType === 'default') {
      switch (this.selectedCategory) {
        case 'newlyArrived':
          this.products = this.newlyArrivedProducts || [];
          break;
        case 'bestOffer':
          this.products = this.bestOfferProducts || [];
          break;
        case 'topQuality':
          this.products = this.topQualityProducts || [];
          break;
        case 'popular':
          this.products = this.popularProducts || [];
          break;
        default:
          this.products = allProducts; // Show all products by default
      }
    } else if (this.selectedCategoryType === 'custom') {
      // Find the category object from the categories array
      const selectedCategoryObj = this.categories.find((c) => c.name === this.selectedCategory);

      if (selectedCategoryObj) {
        // Filter products by category ID
        this.products = allProducts.filter((product) => product.category === selectedCategoryObj.id);
        
      } else {
        // If no category is found, show all products
        this.products = allProducts;
      }
    }

  }

  changeCategory(category: string) {
    this.selectedCategory = category;
    this.selectedCategoryType = 'default'; // Reset to default category type
    this.updateProductList();
    this.scrollToProductsSection(); // Scroll to the products section
  }

  if (selectedCategoryObj : any) {
    // Filter products by category ID
    this.products = [
      ...(this.newlyArrivedProducts || []),
      ...(this.bestOfferProducts || []),
      ...(this.topQualityProducts || []),
      ...(this.popularProducts || [])
    ].filter((product) => product.category === selectedCategoryObj.id);
  }

  filterProductsByCategory(category: any) {
    // Set the selected category name
    this.selectedCategory = category.name;
    this.selectedCategoryType = 'custom'; // Set to custom category type
  
    // Find the category object from the categories array
    const selectedCategoryObj = this.categories.find((c) => c.name === this.selectedCategory);  
    if (selectedCategoryObj?._id) {
    
      // Filter products by category ID
      this.products = [
        ...(this.newlyArrivedProducts || []),
        ...(this.bestOfferProducts || []),
        ...(this.topQualityProducts || []),
        ...(this.popularProducts || [])
      ].filter((product) => product.category === selectedCategoryObj._id);
    } else {
      // If no category is found, show all products
      this.products = [
        ...(this.newlyArrivedProducts || []),
        ...(this.bestOfferProducts || []),
        ...(this.topQualityProducts || []),
        ...(this.popularProducts || [])
      ];
    }
  
    this.scrollToProductsSection(); // Scroll to the products section

  }

  scrollToProductsSection() {
    if (this.productsSection) {
      this.productsSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' ,inline: 'center' });
    }
  }
}